import {
  ACTIVITY_GROUPS,
  ActivityGroup,
} from './OnboardingActivities.constant';
import { ActivitiesSelection } from './OnboardingActivities.types';

interface ToggleActivityValueArgs {
  values: string[];
  value: string;
  isMultiple: boolean;
}

export function toggleActivityValue({
  values,
  value,
  isMultiple,
}: ToggleActivityValueArgs): string[] {
  if (values.includes(value)) {
    return values.filter((selectedValue) => selectedValue !== value);
  }

  if (isMultiple) {
    return [...values, value];
  }

  return [value];
}

interface GetActivitiesSelectionArgs {
  proposedSelection: ActivitiesSelection;
  editedSelection: Partial<ActivitiesSelection>;
}

export const getActivitiesSelection = ({
  proposedSelection,
  editedSelection,
}: GetActivitiesSelectionArgs): ActivitiesSelection => ({
  ...proposedSelection,
  ...editedSelection,
});

export const hasActivitiesProposal = (
  proposedSelection: ActivitiesSelection,
): boolean =>
  ACTIVITY_GROUPS.some((group) => proposedSelection[group].length > 0);

export const isActivitiesSelectionComplete = (
  selection: ActivitiesSelection,
): boolean => ACTIVITY_GROUPS.every((group) => selection[group].length > 0);

const hasSameValues = ({
  left,
  right,
}: {
  left: string[];
  right: string[];
}): boolean =>
  left.length === right.length && left.every((value) => right.includes(value));

interface GetChangedActivityGroupsArgs {
  proposedSelection: ActivitiesSelection;
  selection: ActivitiesSelection;
}

export function getChangedActivityGroups({
  proposedSelection,
  selection,
}: GetChangedActivityGroupsArgs): ActivityGroup[] {
  if (!hasActivitiesProposal(proposedSelection)) {
    return [];
  }

  return ACTIVITY_GROUPS.filter(
    (group) =>
      !hasSameValues({
        left: proposedSelection[group],
        right: selection[group],
      }),
  );
}
